import React,{useState}  from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";
import toast from "react-hot-toast";

export default function UserBlockModal({ hide, userData, ...props }) {
  const { http } = global.services;
  const [isLoading,setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      let status = props?.status === 'blocked' ? `unblock` : `blocked`
      const { data } = await http.put(`users/${props.id}/status/${status}`);
      console.log("handleSubmit", data);
      setLoading(false);
      toast.success('Successfully updated')
      hide("block");
    } catch (err) {
      console.log("error@handleBlock", err);
      toast.error('Something went wrong')
    }finally{
      setLoading(false);
    }
  };

  const Footer = () => {
    return (
      <div className="relative flex flex-row items-center justify-end space-x-2">
        <Button
          buttonName="Cancel"
          buttonClass="bg-thBg py-3 px-9"
          buttonTextClass="text-black text-sm font-bold"
          disabled={isLoading}
          onClick={() => hide()}
        />
        <Button
          key="block-btn"
          buttonName={`Yes, ${props?.status === 'blocked' ? `Unblock` : `Block`}`}
          buttonClass="bg-lightBlack py-3 px-12"
          buttonTextClass="text-white text-sm font-bold"
          disabled={isLoading}
          onClick={handleSubmit}
        />
      </div>
    );
  };

  return (
    <Modal
      footer={<Footer />}
      width="w-19/20 md:w-12/20 2md:w-10/20 3md:w-7/20 1xl:w-5/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-mutedGray"
    >
      <div className="w-full">
        {/* header */}
        <ModalHeader title={`${props?.status === 'blocked' ? `Unblock` : `Block`} User`} hide={hide} />
        {/* content */}
        <div className="pl-10 pr-7 py-7">
          <p className="text-lightBlack">
            Are you sure you want to block user
            <strong> {props.first_name} {props.first_name} ({props.email}) </strong>
            from Milestones Page?
          </p>
        </div>
      </div>
    </Modal>
  );
}
